import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultV2Vo} from '../../common/shared/api/nicolas/vo/ApiResultV2Vo.interface';
import type {InvenMyInfoResultVo} from '../../common/shared/api/nicolas/vo/inven/InvenMyInfoResultVo.interface';

/**
 * 내 인벤 정보 조회
 *
 * Origin: pageNicolasApi.getInvenMyInfo
 * API: GET /gateway/api/v1/inven/my_info
 */
export async function getInvenMyInfo(
  options?: FetcherOptions
): Promise<ApiResultV2Vo<InvenMyInfoResultVo>> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/inven/my_info',
    {
      method: 'GET',
    },
    options
  );
  return response.data;
}
